export default class FilterConfiguration {
    private intermediaryNumber: string | undefined;
    private companyCode: string;
    private scope: string | undefined;
    private segmentCodeList: (string | undefined)[];
    private yearCodeList: string[] | undefined;
    private apiPath: string;

    private constructor(
        intermediaryNumber: string | undefined,
        companyCode: string,
        scope: string | undefined,
        segmentCodeList: (string | undefined)[],
        yearCode: string | undefined,
        apiPath: string
    ) {
        this.intermediaryNumber = intermediaryNumber;
        this.companyCode = companyCode;
        this.scope = scope;
        this.segmentCodeList = segmentCodeList;
        this.yearCodeList = yearCode !== undefined ? [yearCode] : undefined;
        this.apiPath = apiPath;
    }

    public static ForIntermediaryMonthly(
        intermediaryId: number,
        companyCode: string,
        scope: string | undefined,
        segmentCodeList: (string | undefined)[],
        yearCode: string
    ) {
        return new FilterConfiguration(
            undefined,
            companyCode,
            scope,
            segmentCodeList,
            yearCode,
            `intermediary/${intermediaryId}/monthly`
        );
    }

    public static ForIntermediaryCumulative(
        intermediaryId: number,
        companyCode: string,
        scope: string | undefined,
        segmentCodeList: (string | undefined)[],
        yearCode: string
    ) {
        return new FilterConfiguration(
            undefined,
            companyCode,
            scope,
            segmentCodeList,
            yearCode,
            `intermediary/${intermediaryId}/cumulative`
        );
    }

    public static ForIntermediaryProductStructure(
        intermediaryId: number,
        companyCode: string,
        scope: string | undefined,
        segmentCodeList: (string | undefined)[],
        yearCode: string
    ) {
        return new FilterConfiguration(
            undefined,
            companyCode,
            scope,
            segmentCodeList,
            yearCode,
            `intermediary/${intermediaryId}/product-structure`
        );
    }

    public static ForIntermediaryClaimRatio(
        intermediaryId: number,
        companyCode: string,
        segmentCodeList: (string | undefined)[]
    ) {
        return new FilterConfiguration(
            undefined,
            companyCode,
            undefined,
            segmentCodeList,
            undefined,
            `intermediary/${intermediaryId}/claim-ratio`
        );
    }

    public static ForSalesPersonMonthly(
        salesPersonId: number,
        intermediaryNumber: string,
        companyCode: string,
        segmentCodeList: (string | undefined)[],
        yearCode: string
    ) {
        return new FilterConfiguration(
            intermediaryNumber,
            companyCode,
            undefined,
            segmentCodeList,
            yearCode,
            `sales-person/${salesPersonId}/monthly`
        );
    }

    public static ForSalesPersonCumulative(
        salesPersonId: number,
        intermediaryNumber: string,
        companyCode: string,
        segmentCodeList: (string | undefined)[],
        yearCode: string
    ) {
        return new FilterConfiguration(
            intermediaryNumber,
            companyCode,
            undefined,
            segmentCodeList,
            yearCode,
            `sales-person/${salesPersonId}/cumulative`
        );
    }

    public static ForSalesPersonProductStructure(
        salesPersonId: number,
        intermediaryNumber: string,
        companyCode: string,
        segmentCodeList: (string | undefined)[],
        yearCode: string
    ) {
        return new FilterConfiguration(
            intermediaryNumber,
            companyCode,
            undefined,
            segmentCodeList,
            yearCode,
            `sales-person/${salesPersonId}/product-structure`
        );
    }

    public getQueryPath() {
        const params: string[] = [];
        if (this.intermediaryNumber) {
            params.push(`intermediaryNumber=${this.intermediaryNumber}`);
        }
        if (this.scope) {
            params.push(`reportScope=${this.scope}`);
        }
        params.push(`companyCode=${this.companyCode}`);
        params.push(`segmentCodeList=${this.segmentCodeList.join(",")}`);
        if (this.yearCodeList) {
            params.push(`yearCodeList=${this.yearCodeList}`);
        }

        return `${this.apiPath}?${params.join("&")}`;
    }
}
